import PropTypes from 'prop-types';
import classNames from 'classnames';

import { LoadingSection } from 'commonsComponents/loadingSection';

import './loadingScreen.scss';

export const LoadingScreen = ({ isMobile }) => {
    const loadingClass = classNames('screen-loading', {
        'screen-loading--mobile': isMobile
    })

    return  (
        <div className={loadingClass}>
            <div className="screen-loading__modal">
                <LoadingSection />
            </div>
        </div>
    )
}

LoadingScreen.propTypes = {
    isMobile: PropTypes.bool
};

LoadingScreen.defaultProps = {
    isMobile: false
};
